import getOffset from "../../utils/getOffset";

export const ShowFormLoading = element => {
    element.classList.add("loading");
};

export const HideFormLoading = element => {
    element.classList.remove("loading");
};

export const SetShowZipCodeError = doShow => {
    const zipCodeInput = document.querySelector("#zipcode");
    const zipCodeError = document.querySelector('.error-msg[for="zipcode"]');
    if (doShow) {
        zipCodeInput.classList.add("error");
        zipCodeError.classList.remove("hidden");
    } else {
        zipCodeInput.classList.remove("error");
        zipCodeError.classList.add("hidden");
    }
};

export const ToggleError = showError => {
    showError ? document.body.classList.add("coverage-tool-error") : document.body.classList.remove("coverage-tool-error");
    const coverageErrorMessage = document.querySelector(".coverage-error-message");
    if (coverageErrorMessage) {
        window.scrollTo({ top: getOffset(coverageErrorMessage), behavior: "smooth" });
    }
};

export const updateMonth = element => {
    if (element) {
        const m_names = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const d = new Date();
        const month = m_names[d.getMonth()];
        const year = d.getFullYear();
        const textLastP = element.textContent || element.innerText;
        element.innerHTML = `${textLastP} ${month} ${year}.`;
    }
};
